
/**
 * 인증 컨텍스트 정보
 */
export type ProjectCommentListResponsePageAllOfThreeContentItemAuth = {
  /** 현재 사용자의 인증 상태 */
  isAuthenticated: boolean;
  /** 요청한 사용자 정보가 현재 로그인한 사용자인지 여부 */
  isCurrentUser: boolean;
};
